import { MessageEntry }     from './message-entry';
import { isNull }           from "util";

/**
 * How the messaging component works:
 *
 * An empty Message object is created at the beginning
 * of some action or sequence of actions.
 *
 * This Message is passed to each of the methods that
 * could throw errors or have information that needs to
 * be reported back to the user.  As those things occur,
 * they are appended to the list of MessageEntry objects
 * using "add()".
 *
 * When the action is complete and the Message needs to
 * be displayed, the "show()" method is called. It finds
 * the most important message (based on the value of the
 * level) and displays that to the user in the alert
 * area at the top of the page.
 *
 *
 */
export class Message {

	constructor(entry: MessageEntry) {
		this.add(entry);
	}

	// Array of MessageEntry objects received.
	messageEntrys: MessageEntry[] = [];

	/**
	 * Receive another message for the queue,
	 * vet its contents and add it to the
	 * internal MessageEntry array.
	 *
	 * @param msg    MessageEntry  A MessageEntry object.
	 * @param flush  boolean       Whether the existing entries should be flushed.
	 */
	add( msg: MessageEntry, flush: boolean = false ) {

		// Sanity checks on incoming messageEntrys.
		msg.level = ( msg.level < 0 ) ? 0 : msg.level;
		msg.level = ( msg.level > 4 ) ? 4 : msg.level;
		if ( ( isNull( msg.link ) && ! isNull( msg.linkText ) ) || ( ! isNull( msg.link ) && isNull( msg.linkText ) ) ) {
			msg.link = null;
			msg.linkText = null;
		}
		if ( isNull( msg.message ) ) {
			msg.message = 'NULL message text given.';
		}

		if ( flush ) {
			this.flush();
		}

		this.messageEntrys.push( msg );

	}

	/**
	 * How many messageEntrys are there in this object?
	 *
	 * @returns number
	 */
	count() {
		return this.messageEntrys.length;
	}


	/**
	 * Remove all existing entries added to the message.
	 *
	 */
	flush() {
		this.messageEntrys.length = 0;
	}

	/**
	 * Get the highest-ranking message among the message objects
	 * received.  In the case where there are multiple messageEntrys
	 * of the same highest level, the last one wins.
	 *
	 * @returns MessageEntry  The highest-ranking message, or a created message if none were added.
	 */
	show() {

		if ( 0 === this.count() ) {
			let nMsg = new MessageEntry();
			nMsg.message = 'Completed';
			return nMsg;
		}

		let highest = 0;
		let match = null;

		for ( let msg of this.messageEntrys ) {
			if ( msg.level >= highest ) {
				highest = msg.level;
				match = msg;
			}
		}

		return match;

	}

	/**
	 * Concatenate the text of all the messageEntrys
	 * received and return it.  It returns
	 * 'No messageEntrys in queue.' if none were added.
	 *
	 * @returns string The concatenated messageEntrys.
	 */
	showAll() {

		if ( 0 === this.count() ) {
			return 'No messageEntrys in queue.';
		}

		let accumulated = '';
		while ( this.count() > 0 ) {

			if ( accumulated.length > 0 ) {
				accumulated = accumulated.concat('|');
			}
			accumulated = accumulated.concat( this.messageEntrys.pop().message );

		}

		return accumulated;

	}

}



// WEBPACK FOOTER //
// ./src/app/services/message/message.ts